module.exports = __webpack_public_path__ + "img/16.c09d0160.png";